<template>
  <div class="news">
    <div class="main-contain">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: "news",
  components: {},
  data() {
    return {};
  },
  computed: {},
  methods: {
    // 判断浏览环境是手机端和pc端
    getBrowserMobile() {
      const regBrowser =
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i;
      this.isMobile = navigator.userAgent.match(regBrowser) ? true : false; // 判断是否是手机浏览
      return this.isMobile;
    },
  },
};
</script>
<style scoped lang="scss">
.news {
  .main-contain {
    width: 100%;
    max-width: 1400px;
    margin: 0 auto 30px;
  }
}
@media screen and (max-width: 640px) {
  .news {
    .main-contain {
      max-width: 640px;
      padding: 0 10px;
      box-sizing: border-box;
    }
  }
}

@media screen and (min-width: 640px) and (max-width: 1200px) {
  .news {
    .main-contain {
      max-width: 1200px;
    }
  }
}
@media screen and (min-width: 1200px) {
  .news {
    .main-contain {
      max-width: 1400px;
    }
  }
}
</style>